// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sankey-wrapper,.top-paths-wrapper{background-color:var(--background-color);height:100%;position:relative}.sankey-wrapper.download-mode{height:700px}.top-paths-wrapper.download-mode{height:unset}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
